import { combineReducers } from "redux";

// Slices
import permissionsSlice from "./permissions/permissionsSlice";
import { userOrgsSlice } from "./userOrgs";
import userSelectedHubSlice from "./userSelectedHub/userSelectedHubSlice";

// Re-export
export * from "./permissions";
export * from "./userOrgs";

const sysadminReducersSlice = combineReducers({
    permissions: permissionsSlice,
    userOrgs: userOrgsSlice,
    userSelectedHub: userSelectedHubSlice,
});

export default sysadminReducersSlice;
